import './style.scss';
document.addEventListener('DOMContentLoaded', function () {
	const zoomTargets = document.querySelectorAll('.lpcb-main-visual__img.is-zoomable:not(.swiper-slide *)');
	if (!zoomTargets.length) return;

	zoomTargets.forEach(img => {
		const observer = new IntersectionObserver(
			([entry], observer) => {
				if (entry.isIntersecting) {
					img.classList.add('is-zooming');
					observer.unobserve(img);
				}
			},
			{ threshold: 0.7 }
		);
		observer.observe(img);
	});
});
